import React from "react";
import { PopUpConstants, shared } from "../../src/taskpane/config/constants";
import { IAuthTokenResultDto } from "../../src/taskpane/interfaces/IAuthTokenResultDto";
import authModule, { DialogMessageResponse, DialogMessageStatus, TokenResource } from "../../utilities/AuthModule";
import generalModule from "../../utilities/GeneralModule";
// import { logger } from "../../utilities/logger";

export function useMailboxPopUpAuth() {
    // const [isMailboxTokenAvailable, setIsMailboxTokenAvailable] = React.useState<boolean>(authModule.getPersistedAuthState()?.mailboxToken?.length > 0);
    const [isMailboxTokenAvailable, setIsMailboxTokenAvailable] = React.useState<boolean>(true);
    const [isMailboxTokenRequestInProgress, setIsMailboxTokenRequestInProgress] = React.useState<boolean>(false);

    const authDialogRef = React.useRef<any>();

    const requestMailboxToken = async () => {
        if (generalModule.isInConentMangerMode()) {
            let authState: IAuthTokenResultDto = authModule.getPersistedAuthState();

            let authUrl: URL = new URL(`${process.env.baseUri}/auth.html`);
            authUrl.searchParams.append(shared.params.app, "content_manager");
            authUrl.searchParams.append(shared.params.resource, TokenResource.Mailbox.toString());
            authUrl.searchParams.append(shared.params.username, authState.account?.username);
            /**
             * adding winLeft and winTop to account for dual monitor
             * using screenLeft and screenTop for IE8 and earlier
             */
            const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
            const winTop = window.screenTop ? window.screenTop : window.screenY;
            /**
             * window.innerWidth displays browser window"s height and width excluding toolbars
             * using document.documentElement.clientWidth for IE8 and earlier
             */
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const left = Math.max(0, ((width / 2) - (PopUpConstants.POPUP_WIDTH / 2)) + winLeft);
            const top = Math.max(0, ((height / 2) - (PopUpConstants.POPUP_HEIGHT / 2)) + winTop);

            authDialogRef.current = window.open(authUrl.href, `${PopUpConstants.POPUP_NAME_PREFIX}.${TokenResource.Mailbox}`, `width=${PopUpConstants.POPUP_WIDTH}, height=${PopUpConstants.POPUP_HEIGHT}, top=${top}, left=${left}, scrollbars=yes`);
        }
        else {
            await authModule.initiateDialogAuthFlow(loginCallback, TokenResource.Mailbox);
        }
    }

    // const processAuthDialogResponse = (event) => {
    //     if (event.origin != process.env.baseUri)
    //         return;

    //     try {
    //         if (event.data) {
    //             const messageFromDialog: DialogMessageResponse = event.data;
    //             if (messageFromDialog?.status === DialogMessageStatus.Success) {
    //                 if (messageFromDialog.result?.mailboxToken?.length > 0) {
    //                     let authState: IAuthTokenResultDto = authModule.getPersistedAuthState();
    //                     if (authState) {
    //                         authState.mailboxToken = messageFromDialog.result.mailboxToken;
    //                         authState.mailboxTokenExpiresOn = messageFromDialog.result.mailboxTokenExpiresOn;
    //                         authModule.persistAuthState(authState);
    //                         setIsMailboxTokenAvailable(true);
    //                     }
    //                 }
    //             }
    //         }
    //     } catch (error) {
    //         logger(error, "useMailboxPopUpAuth.tsx (processAuthDialogResponse)", event.data);
    //     }

    //     authDialogRef?.current?.close();
    // }

    const loginCallback = async (authResult: IAuthTokenResultDto) => {
        // if (authResult) {
        //     setIsMailboxTokenAvailable(authResult?.mailboxToken?.length > 0);
        // }
    };

    // React.useEffect(() => {
    //     window.addEventListener("message", processAuthDialogResponse);
    //     if (!isMailboxTokenAvailable) {
    //         (async () => {
    //             setIsMailboxTokenRequestInProgress(true);
    //             const mailboxToken: string = await authModule.getMailboxAccessToken(true);
    //             if (mailboxToken) {
    //                 setIsMailboxTokenAvailable(true);
    //             }
    //             setIsMailboxTokenRequestInProgress(false);
    //         })();
    //     }
    //     return () => {
    //         window.removeEventListener("message", processAuthDialogResponse);
    //     };
    // }, [isMailboxTokenAvailable]);

    return { isMailboxTokenAvailable, isMailboxTokenRequestInProgress, requestMailboxToken }
}